import Box from 'components/ui/box';
import { useEffect, useState } from 'react';
import { RiArrowLeftSLine } from 'react-icons/ri';
import { Link } from 'react-router-dom';
import { getManifest, IManifest } from 'services/manifest.service';
import { CopaThemePlayerProvider } from 'pages/Copa/CopaThemePlayerContext';
import { ThemePlayer } from 'pages/Copa/components/ThemePlayer';

import './styles.scss';
import { useAuth } from 'context/AuthContext';

export function Manifesto() {
  const [manifest, setManifest] = useState<IManifest>();
  const [load, setLoad] = useState<boolean>(true);
  const { user } = useAuth();

  useEffect(() => {
    async function loadData() {
      const data = await getManifest(user?.extra.rede);
      if (data) {
        setManifest(data);
      }

      setLoad(false);
    }

    loadData();
  }, []);

  return (
    <div className=" mx-auto container p-3 lg:p-10">
      <div className="flex flex-ro items-center space-x-3 lg:space-x-6 mb-3 lg:mb-10">
        <div>
          <Link to="../" tabIndex={-1}>
            <button className="rounded-full bg-purple flex justify-center items-center p-1" tabIndex={0} aria-label="Voltar">
              <RiArrowLeftSLine size={28} className="text-white" />
            </button>
          </Link>
        </div>

        <h1 className="text-xl lg:text-3xl ">Manifesto</h1>
      </div>

      <Box>
        {/*
          A letra do tema é sobre os valores do manifesto (colaboração, ética,
          protagonismo), então a trilha entra aqui como tema institucional — não
          como artefato da campanha da Copa. Daí o `themeName` próprio e a
          telemetria desligada: os eventos `copa_interaction` alimentam o
          relatório da Copa, e esta página não é a campanha.

          O provider é local: a trilha para quando o usuário sai do Manifesto.

          O título "MANIFESTO #JOGAJUNTOBB" vem do CMS (`manifest__c.text`), então
          o player não pode dividir a linha com ele pelo markup — é sobreposto à
          direita dessa linha via `.manifesto-conteudo`/`.manifesto-player`
          (posicionamento em styles.scss). Fica FORA da div `.manifesto`, cujo CSS
          estiliza h1..h6/p/ul/ol e vazaria sobre o player.
        */}
        <div className="manifesto-conteudo">
          <CopaThemePlayerProvider>
            <div className="manifesto-player">
              <ThemePlayer themeName="Joga Junto BB" telemetry={false} />
            </div>
          </CopaThemePlayerProvider>

          {load && <div>Carregando...</div>}
          {!load && (
            <div className="manifesto space-y-5 lg:p-3">
              <div className="text-lg text-white p-3 space-y-5">
                {manifest?.text && <div dangerouslySetInnerHTML={{ __html: manifest.text }}></div>}
              </div>
            </div>
          )}
        </div>
      </Box>
    </div>
  );
}
